/**
 * Made by Kudzai
 */

document.addEventListener("DOMContentLoaded", function () {
  let isButtonAlreadyMovedToTheBotton = false;

  const addToCartButton = document.querySelector('button[name="add"]');

  function updateAddToCartButtonText() {
    const cowCalenderButton = document.querySelector(".cowlendar-btn");
    if (cowCalenderButton) {
      const buttonText = cowCalenderButton.querySelector("span");
      if (buttonText) {
        buttonText.textContent = "Book now";
      }
    }

    const buttonText = addToCartButton.querySelector("span");
    if (buttonText) {
      // if (buttonText.textContent.toLowerCase().trim() == "add to cart")
      buttonText.textContent = "Buy now, book later";
    }
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
  function updateAddToCartButtonVisibility() {
    // const bookNowButtonButton = document.querySelector(".cowlendar-btn-0, .cowlendar-btn-1");
    // if (!bookNowButtonButton) return;

    let bookLaterButton = document.querySelector(
      ".gpo-clone-atc-button.cowlendar-add-to-cart"
    );

    if (!bookLaterButton) {
      console.log("bb no cloned add to cart");
      bookLaterButton = document.querySelector('[class*="cowlendar-add-to-cart"]');//document.querySelector(".cowlendar-add-to-cart");
    } else {
      console.log("bb cloned present - add to cart");
    }
    if (!bookLaterButton) {
      console.log("bb no add to cart button");
      return;
    }

    if (isVisible(bookLaterButton)) {
      console.log("bb bookLater Button visible");
      return;
    }
    bookLaterButton.style.setProperty("display", "block", "important");
     const buttonText = bookLaterButton.querySelector("span");
    if (buttonText) {
      if (buttonText.textContent.toLowerCase().trim() == "add to cart")
      buttonText.textContent = "Buy now, book later";
    }
    console.log("bb udpate to visible");
  }

  function updateAddToCartButtonPosition() {
    if (!isButtonAlreadyMovedToTheBotton) {
      const buttonContainer = document.querySelector(".product-form__buttons");
      buttonContainer.appendChild(addToCartButton);
      isButtonAlreadyMovedToTheBotton = true;
    }
  }
  function initAddBookLaterButtonOnConsultationPage() {
    // updateAddToCartButtonText();
    // updateAddToCartButtonVisibility();

    // const observer = new MutationObserver((mutationsList) => {
    //   for (let mutation of mutationsList) {
    //     if (
    //       mutation.type === "attributes" &&
    //       mutation.attributeName === "style"
    //     ) {
    //       updateAddToCartButtonText();
    //       updateAddToCartButtonVisibility();
    //       updateAddToCartButtonPosition();
    //     }
    //   }
    // });

    const buttonContainer = document.querySelector(".product-form__buttons");

    let clonedBtn = addToCartButton.cloneNode(true); 
    console.log("bb Cloned ", clonedBtn);
    clonedBtn.classList.add("bbAdded");
    clonedBtn.classList.remove("cowlendar-add-to-cart");
    clonedBtn.classList.remove("product-form__submit");

    clonedBtn.classList.forEach(cls => {
    if (cls.startsWith('cowlendar-add-to-cart')) {
      clonedBtn.classList.remove(cls);
    }
  });
  clonedBtn.type = 'button';
  clonedBtn.name ="bbAdd";

    clonedBtn.id="BBZAddedB";
    clonedBtn.style.setProperty("display", "block", "important");
     const buttonText = clonedBtn.querySelector("span");
    if (buttonText) {
      if (buttonText.textContent.toLowerCase().trim() == "add to cart")
      buttonText.textContent = "Buy now, book later";
    }

    clonedBtn.addEventListener('click', function (e) {
       
  // Only show the spinner inside THIS button
  const spinner = this.querySelector('.loading__spinner');
  if (spinner) {
    spinner.classList.remove('hidden');
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  const form = e.target.closest('form');
  if (!form) return;
const variantId = form.querySelector('[name="id"]')?.value;
  const quantity = form.querySelector('[name="quantity"]')?.value || 1;

const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  // Use fetch in the iframe context
  iframe.contentWindow.fetch('/cart/add.js?_cowbypass=1', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(data => {
    console.log('Added to cart via iframe fetch:', data);

    // Redirect to cart after success
    window.location.href = '/cart';
  })
  .catch(err => console.error('Error adding to cart:', err));
return;

  // 🧠 Use a renamed endpoint that Cowlendar won’t detect
  fetch(window.Shopify.routes.root + "cart/add.js?_cowbypass=1", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    })
    .then(() => {
      window.location.href = "/cart";
    })
    .catch((err) => console.error("Add to cart error:", err));

},true);

    setTimeout(() => {
    buttonContainer.appendChild(clonedBtn);
      const originalButton = document.querySelector('[class*="cowlendar-add-to-cart"]');//document.querySelector(".cowlendar-add-to-cart");
      console.log("bb og button", originalButton);
      if(originalButton)
      {
        originalButton.remove();
        // originalButton.style.setProperty("display", "none", "important");
      }
    },2000);


    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {
//           document.querySelectorAll('.bbAdded').forEach(el => {
//   el.style.display = 'none';
// });
          clonedBtn = document.getElementById('BBZAddedB');
          if(clonedBtn)
          {
          clonedBtn.style.setProperty("display", "block", "important");

           console.log("bb Cloned Changed to:" , clonedBtn);
          }
          
        }
      }
    });

    
    // Configure the observer to watch for attribute changes
    observer.observe(clonedBtn, { attributes: true });

    const select = document.querySelector(".gpo-select select");

    document.addEventListener("change", function (e) {
      if (e.target.matches("select")) {
        console.log("Changed to:", e.target.value);
        // updateAddToCartButtonText();
        // updateAddToCartButtonVisibility();
        // updateAddToCartButtonPosition();
      }
    });

if (buttonContainer) {
  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: false };

  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, buttonContainerObserver) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            console.log('bb New element added:', node);
            // You can do additional logic here
               // updateAddToCartButtonVisibility();
          }
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const buttonContainerObserver = new MutationObserver(callback);

  // Start observing the target node
  buttonContainerObserver.observe(buttonContainer, config);
} else {
  console.warn('Button container not found');
}
  }

  if (document.querySelector(".bb-wig-consultation")) {
     initAddBookLaterButtonOnConsultationPage();
  }

  // hide next day on all coloured wigs
  const container = document.querySelector(".bb-coloured-wig");

  if (container) {
    // Add a 2-second delay
    setTimeout(() => {
      // Find the select element with a name containing "Processing Time"
      const selectElement = container.querySelector(
        'select[name*="Processing Time"]'
      );
      // console.log("bb hey");

      if (selectElement) {
        // console.log("bb found ");
        // Find the option with a value containing "Next Working Day"
        const optionToHide = Array.from(selectElement.options).find((option) =>
          option.value.includes("Next Working Day")
        );

        if (optionToHide) {
          console.log("bb option found");
          // Hide the option
          optionToHide.style.display = "none";
        }
      }
    }, 2000); // 2000 milliseconds = 2 seconds
  }

  function initPreOrder() {
    const productForm = document.querySelector(".product-form");
    if (!productForm) {
      console.log("kb no product form");
    }

    function updateButtonText() {
      console.log("kb udpate button");
      const addToCartButton = document.querySelector('button[name="add"]');
      if (!addToCartButton) return;

      const buttonText = addToCartButton.querySelector("span");
      if (!buttonText) return;

      const selectedVariant = document.querySelector(
        'input[type="radio"]:checked, select[name="id"]'
      );

      if (!selectedVariant) return;

      const soldOutButContinue = selectedVariant.getAttribute(
        "data-sold_out_but_continue"
      );

      console.log("kb udpate sold", soldOutButContinue);

      if (soldOutButContinue === "true") {
        buttonText.textContent = "Pre Order";
      } else {
        buttonText.textContent =
          addToCartButton.dataset.originalText || "Add to Cart";
      }
      console.log("kb +" + buttonText.textContent);
    }

    //productForm.addEventListener("change", updateButtonText);

    const addToCartButton = document.querySelector('button[name="add"]');

    // Store original button text
    if (addToCartButton) {
      const buttonText = addToCartButton.querySelector("span");
      addToCartButton.dataset.originalText = buttonText.textContent;

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "attributes") {
            updateButtonText();
          }
        }
      });

      // Configure the observer to watch for attribute changes
      observer.observe(addToCartButton, {
        childList: true,
        attributes: true,
        subtree: true,
      });
    }

    // Initial check on page load
    updateButtonText();
  }
  if (!document.querySelector(".bb-wig-consultation")) initPreOrder();
});
